(() => {
  if (customElements.get('hp-legal-layout')) return;

  class HpLegalLayout extends HTMLElement {
    connectedCallback() {
      this.scrollActiveNavIntoView();
      this.optimizeContentImages();
    }

    optimizeContentImages() {
      const content = this.querySelector('.hp-legal-layout__content');
      if (!content) return;

      const images = [...content.querySelectorAll('img')];
      images.forEach((img, index) => {
        img.decoding = 'async';

        if (!img.getAttribute('loading')) {
          img.loading = index === 0 ? 'eager' : 'lazy';
        }

        if (index === 0 && !img.getAttribute('fetchpriority')) {
          img.fetchPriority = 'high';
        }
      });
    }

    scrollActiveNavIntoView() {
      const activeLink = this.querySelector('.hp-legal-layout__nav-link--mobile.is-active');
      if (!activeLink) return;

      const scrollContainer = activeLink.closest('.hp-legal-layout__mobile-scroll');
      if (!scrollContainer) return;

      const containerRect = scrollContainer.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();
      const targetScrollLeft =
        scrollContainer.scrollLeft +
        (linkRect.left - containerRect.left) -
        containerRect.width / 2 +
        linkRect.width / 2;

      scrollContainer.scrollTo({
        left: Math.max(0, targetScrollLeft),
        behavior: 'smooth',
      });
    }
  }

  customElements.define('hp-legal-layout', HpLegalLayout);
})();
